export default "__VITE_ASSET__7f6dbc3a__"